import { render, staticRenderFns } from "./BirthdayView.vue?vue&type=template&id=76699d4e&scoped=true&"
import script from "./BirthdayView.vue?vue&type=script&lang=js&"
export * from "./BirthdayView.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayView.vue?vue&type=style&index=0&id=76699d4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76699d4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
